// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PropertyPrice = require("../../common/Property/PropertyPrice.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RentalPropertyLease = require("../../common/Property/RentalPropertyLease.bs.js");
let Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");
let AgentPropertyLocation = require("../../common/Agent/AgentPropertyLocation.bs.js");
let LotPropertyAttributes = require("../../common/Property/LotPropertyAttributes.bs.js");
let AgentPropertyMlsStatus = require("../../common/Agent/AgentPropertyMlsStatus.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let CondoPropertyAttributes = require("../../common/Property/CondoPropertyAttributes.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let MultiUnitPropertyAttributes = require("../../common/Property/MultiUnitPropertyAttributes.bs.js");
let SingleFamilyPropertyAttributes = require("../../common/Property/SingleFamilyPropertyAttributes.bs.js");
let PropertyMlsValidationStatusComponents = require("../propertyForms/Geocoding/PropertyMlsValidationStatusComponents.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts = require("./PropertyWizardFormRelay__Validators__KeyFacts.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__Price = require("./PropertyWizardFormRelay__Validators__KeyFacts__Price.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__Address = require("./PropertyWizardFormRelay__Validators__KeyFacts__Address.bs.js");
let PropertyWizardRelayPreviewPropertyDetails_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewPropertyDetails_formState_graphql.bs.js");
let PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql.bs.js");
let PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.bs.js");
let PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localGeocodingStatus_decode = PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.Utils.localGeocodingStatus_decode;

let FormStateFragment_localGeocodingStatus_fromString = PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.Utils.localGeocodingStatus_fromString;

let FormStateFragment = {
  localGeocodingStatus_decode: FormStateFragment_localGeocodingStatus_decode,
  localGeocodingStatus_fromString: FormStateFragment_localGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.node, convertFragment$2, fRef);
}

let DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyWizardRelay__Preview__PropertyDetails$StreetAddress(props) {
  let onErrorClick = props.onErrorClick;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_localDraft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_formState_graphql.node, convertFragment$1, props.formState);
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.node, convertFragment$2, props.displayHelpers);
  let match = PropertyWizardFormRelay.Context.use();
  let isValid = PropertyWizardFormRelay__Validators__KeyFacts__Address.StreetAddress.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let match$1 = formState.geocodingStatus;
  let exit = 0;
  if (isValid !== undefined && isValid.NAME !== "Invalid") {
    let propertyLocation = displayHelpers.propertyLocation;
    if (propertyLocation !== undefined) {
      return JsxRuntime.jsx(AgentPropertyLocation.ByPropertyLocation.make, {
        propertyLocation: propertyLocation.fragmentRefs,
        shouldShowPropertyDetails: true
      });
    } else {
      return null;
    }
  }
  exit = 1;
  if (exit === 1) {
    if (match$1 === "Called") {
      return null;
    }
    if (isValid === undefined) {
      return JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
        text: "Street address is required",
        onClick: param => onErrorClick()
      });
    }
    let exit$1 = 0;
    if (isValid.VAL === "propertyAlreadyOnMls") {
      if (match.mode === "New") {
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(PropertyMlsValidationStatusComponents.AlreadyOnMlsCannotBeBroadcast.make, {}),
            JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
              text: "Go to the street address section",
              onClick: param => onErrorClick()
            })
          ],
          className: "flex flex-col space-y-4"
        });
      }
      exit$1 = 2;
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      return JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
        text: "The street address is invalid",
        onClick: param => onErrorClick()
      });
    }
  }
}

let StreetAddress = {
  DraftFragment: DraftFragment,
  FormStateFragment: FormStateFragment,
  DisplayHelpersFragment: DisplayHelpersFragment,
  Validator: undefined,
  make: PropertyWizardRelay__Preview__PropertyDetails$StreetAddress
};

let convertFragment$3 = PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.node, convertFragment$3, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$1 = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

let convertFragment$4 = PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql.node, convertFragment$4, fRef);
}

let DisplayHelpersFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

let convertFragment$5 = PropertyWizardRelayPreviewPropertyDetails_formState_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewPropertyDetails_formState_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetails_formState_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewPropertyDetails_formState_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewPropertyDetails_formState_graphql.node, convertFragment$5, fRef);
}

let FormStateFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function PropertyWizardRelay__Preview__PropertyDetails$Display(props) {
  let priceOverride = props.priceOverride;
  let propertyLocationOverride = props.propertyLocationOverride;
  let availableFrom = props.availableFrom;
  let propertyType = props.propertyType;
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetails_displayHelpers_graphql.node, convertFragment$4, props.displayHelpers);
  let streetAddressDisplayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers_graphql.node, convertFragment$2, displayHelpers.fragmentRefs);
  let propertyLocation;
  if (propertyLocationOverride !== undefined) {
    propertyLocation = propertyLocationOverride;
  } else {
    let propertyLocation$1 = streetAddressDisplayHelpers.propertyLocation;
    propertyLocation = propertyLocation$1 !== undefined ? JsxRuntime.jsx(AgentPropertyLocation.ByPropertyLocation.make, {
        propertyLocation: propertyLocation$1.fragmentRefs,
        shouldShowPropertyDetails: true
      }) : null;
  }
  let price;
  if (priceOverride !== undefined) {
    price = priceOverride;
  } else {
    let price$1 = displayHelpers.price;
    if (price$1 !== undefined) {
      let tmp;
      tmp = propertyType === "FOR_SALE" ? null : "/month";
      price = JsxRuntime.jsx(PropertyPrice.PriceInternal.PriceDisplay.make, {
        propertyPrice: price$1.fragmentRefs,
        children: tmp
      });
    } else {
      price = null;
    }
  }
  let condoProperty = displayHelpers.condoProperty;
  let attributes;
  if (condoProperty !== undefined) {
    attributes = JsxRuntime.jsx(CondoPropertyAttributes.make, {
      propertyType: condoProperty.fragmentRefs
    });
  } else {
    let lotProperty = displayHelpers.lotProperty;
    if (lotProperty !== undefined) {
      attributes = JsxRuntime.jsx(LotPropertyAttributes.make, {
        propertyType: lotProperty.fragmentRefs,
        displayPropertyType: false
      });
    } else {
      let multiUnitProperty = displayHelpers.multiUnitProperty;
      if (multiUnitProperty !== undefined) {
        attributes = JsxRuntime.jsx(MultiUnitPropertyAttributes.make, {
          propertyType: multiUnitProperty.fragmentRefs,
          displayPropertyType: true
        });
      } else {
        let singleFamilyProperty = displayHelpers.singleFamilyProperty;
        attributes = singleFamilyProperty !== undefined ? JsxRuntime.jsx(SingleFamilyPropertyAttributes.make, {
            propertyType: singleFamilyProperty.fragmentRefs
          }) : null;
      }
    }
  }
  let match = displayHelpers.leaseLength;
  let leaseInfo;
  leaseInfo = propertyType === "FOR_SALE" || availableFrom === undefined || match === undefined ? null : JsxRuntime.jsx(RentalPropertyLease.DisplayAttributes.make, {
      leaseLengthDisplayName: match.displayName,
      availableFrom: Primitive_option.valFromOption(availableFrom)
    });
  let mlsPlan = displayHelpers.mlsPlan;
  let mlsStatus = mlsPlan !== undefined ? JsxRuntime.jsx(AgentPropertyMlsStatus.FromMlsPlan.make, {
      mlsPlan: mlsPlan.fragmentRefs,
      activeOnMlsSince: undefined
    }) : null;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: propertyLocation
      }),
      JsxRuntime.jsx("div", {
        children: price
      }),
      JsxRuntime.jsx("div", {
        children: attributes
      }),
      JsxRuntime.jsx("div", {
        children: leaseInfo
      }),
      JsxRuntime.jsx("div", {
        children: mlsStatus
      }),
      Stdlib_Option.getOr(props.footer, null)
    ],
    className: "flex flex-col space-y-4"
  });
}

let Display = {
  make: PropertyWizardRelay__Preview__PropertyDetails$Display
};

function PropertyWizardRelay__Preview__PropertyDetails(props) {
  let onEditForm = props.onEditForm;
  let displayHelpers = props.displayHelpers;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetails_localDraft_graphql.node, convertFragment$3, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewPropertyDetails_formState_graphql.node, convertFragment$5, props.formState);
  let isValid = PropertyWizardFormRelay__Validators__KeyFacts.use(draft.fragmentRefs, formState.fragmentRefs);
  let priceValid = PropertyWizardFormRelay__Validators__KeyFacts__Price.useIsValid(draft.fragmentRefs);
  let priceOverride = priceValid === "Invalid" ? JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
      text: "Price is missing or incorrect",
      onClick: _event => onEditForm("keyFacts")
    }) : undefined;
  let footer = isValid === "Invalid" ? JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
      text: "Property details are missing",
      onClick: _event => onEditForm("keyFacts")
    }) : undefined;
  return JsxRuntime.jsx(PropertyWizardRelay__Preview__PropertyDetails$Display, {
    displayHelpers: displayHelpers,
    propertyType: draft.draftProperty.propertyType,
    availableFrom: draft.draftProperty.availableFrom,
    propertyLocationOverride: JsxRuntime.jsx(PropertyWizardRelay__Preview__PropertyDetails$StreetAddress, {
      draft: draft.fragmentRefs,
      formState: formState.fragmentRefs,
      displayHelpers: displayHelpers,
      onErrorClick: () => onEditForm("keyFacts")
    }),
    priceOverride: priceOverride,
    footer: footer
  });
}

let MissingFieldMarker;

let Validators;

let make = PropertyWizardRelay__Preview__PropertyDetails;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.StreetAddress = StreetAddress;
exports.DraftFragment = DraftFragment$1;
exports.DisplayHelpersFragment = DisplayHelpersFragment$1;
exports.FormStateFragment = FormStateFragment$1;
exports.Display = Display;
exports.make = make;
/* PropertyPrice Not a pure module */
